const GOT_ROLES = 'GOT_ROLES';
const ERROR_FETCHING_ROLES = 'ERROR_FETCHING_ROLES';

export {
  GOT_ROLES,
  ERROR_FETCHING_ROLES,
};
